import localDb from '@util/localDb';
import {queryOrgEnableTree} from "@api/core/org";

// 按模块的action, reducer整合体
const GET_ENABLE_ORGANIZATION_LIST = 'GET_ENABLE_ORGANIZATION_LIST';

// Action
export function getEnableOrganization() {
  return dispatch => {
    queryOrgEnableTree().then(res => {
      if (res.statusCode === 200) {
        localDb.set(GET_ENABLE_ORGANIZATION_LIST, res.data);
        return dispatch({
          type: GET_ENABLE_ORGANIZATION_LIST,
          data: res.data,
        });
      }
    });
  };
}

// Reducer
export function enableOrgTree(state = [], action) {
  switch (action.type) {
    case GET_ENABLE_ORGANIZATION_LIST:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/enable_org_tree.js